<template>
	<div v-if="context?.formulare?.length" role="region" aria-label="Formulare">
		<nk-wrapper
			v-for="(formulare, formulareIndex) in sortedFormulare"
			:key="formulareIndex"
			spacing="md"
		>
			<section>
				<nk-title
					:id="`title-${titleId}`"
					:aria-label="`Alle Formulare mit dem Buchstabe ${formulare.letter}`"
					size="lg"
					tag="h1"
					no-margin
				>
					{{ formulare.letter }}
				</nk-title>
				<nk-nav :aria-labelledby="`title-${titleId}`">
					<nk-nav-item
						v-for="(formular, formularIndex) in formulare.children"
						:key="formularIndex"
						:link="formular.url"
						prepend-icon="false"
						:aria-label="getLinkAriaLabel(formular.name, formular.url)"
					>
						{{ formular.name }}
						<template
							v-if="
								parseUrlData(formular.url).isPDF &&
								!formular.name.toLowerCase().endsWith('(pdf)')
							"
						>
							(PDF)
						</template>
						<template
							v-if="['FORMULAR', 'ONLINEDIENST'].includes(formular.typ)"
						>
							<br />
							<span
								v-if="formular.typ === 'FORMULAR'"
								class="inline-block text-sm"
							>
								<nk-icon icon="file" size="sm" />
								Formular
							</span>
							<span
								v-if="formular.typ === 'ONLINEDIENST'"
								class="inline-block text-sm"
							>
								<nk-icon icon="globe" size="sm" />
								Onlinedienst
							</span>
						</template>
					</nk-nav-item>
				</nk-nav>
			</section>
		</nk-wrapper>
	</div>
</template>

<script>
import {groupBy, map} from 'lodash-es';
import TemplatesDefault from '../../mixins/templates-default';
import {useId} from '#imports';
import {getLinkAriaLabel, parseUrlData} from '#nk/helpers';
/**
 * @prop {array} context.formulare
 * @prop {boolean} options.onlyExternalLinks
 */
export default {
	name: 'NkTemplateServiceBwFormulare',

	mixins: [TemplatesDefault],

	setup() {
		const titleId = useId();
		return {titleId, getLinkAriaLabel, parseUrlData};
	},

	computed: {
		sortedFormulare() {
			let formulare = this.context.formulare;

			if (this.options.onlyExternalLinks) {
				formulare = this.context.formulare.filter(
					formular => !formular.url.includes('/downloads/'),
				);
			}
			const group = groupBy(formulare, o => o.name[0].toUpperCase());
			return map(group, (value, key) => ({
				letter: key,
				children: value,
			}));
		},
	},
};
</script>
